const businessLandingEN = {
	hero: {
		title: "Your business, growing and stress-free",
		subtitle:
			"Whether you have a business or want to start one, Sin Fila automates bookings, reminders, and team management, while helping you attract more clients.",
		primaryCta: "Register now for free",
		storeText: "Available on iOS · Android",
		noteStrong: "Start your 14-day free trial now",
		noteRest: " • Set up your business in just 15 min • Hassle-free, no contracts • Cancel anytime",
	},

	problem: {
		title: "The real problem",
		subtitle: "Does this sound familiar?",
		items: [
			"📱 Responding to WhatsApp all day (and night)",
			"📆 Overlapping schedules or empty slots",
			"🚶 Clients arrive, see a long line… and leave",
			"📊 Not knowing how many clients you served this month",
			"🌐 Struggling to attract new clients and increase your business visibility",
		],
		itemspart2: ["⏳ If there's no customers → you lose time", "😤 If there's too much line → you lose clients."],
		description: "Every client who leaves because of the line is lost revenue.",
		highlight: "Many businesses lose up to 20% of their revenue due to poor appointment management, idle time, and clients who leave while waiting.",
	},

	didYouKnow: {
		title: "Did you know...",
		items: [
			"More than 70% of clients prefer booking online if possible",
			"Automating bookings removes WhatsApp messages all day",
			"Automatic reminders reduce no-shows",
			"Centralizing business sales data helps you make better decisions to grow",
		],
		highlight: "✅ Sin Fila organizes your schedule so you don't lose clients — and gives your business online visibility to grow.",
	},

	solution: {
		title: "Sin Fila solves it",
		points: [
			{
				title: "Never miss a booking",
				desc: "All appointments, confirmations, and reminders in one place.",
			},
			{
				title: "Attract new clients and fill your schedule",
				desc: "Show your business to more clients in our marketplace.",
			},
			{
				title: "Save time managing your shop and staff",
				desc: "Manage your services and staff calendars effortlessly.",
			},
			{
				title: "Effortless bookings for your clients",
				desc: "Clients book, modify, and get reminders automatically.",
			},
		],
	},

	businessBenefits: {
		title: "Key benefits for businesses",
		subtitle: "Organize your schedule, automate appointments, and avoid losing clients.",
		items: [
			"Receive online bookings 24/7",
			"Automatic confirmations and reminders",
			"Clear schedules with no overlaps",
			"Public profile to attract new clients",
			"Less time on WhatsApp — more time working",
		],
	},

	customerBenefits: {
		title: "Key benefits for customers",
		subtitle: "Book your appointment in seconds, without calls or waiting.",
		items: [
			"See real availability",
			"Book instantly",
			"Receive automatic reminders",
			"Reschedule or cancel stress-free",
			"Find barbershops, salons, and more near you",
		],
	},

	howToStart: {
		title: "How to start",
		steps: [
			{ title: "Create your free account", desc: "Register in minutes and set up your business." },
			{ title: "Add your services and team", desc: "Customize your profile and schedules." },
			{ title: "Start receiving bookings", desc: "And let Sin Fila do the rest." },
		],
	},

	pricing: {
		title: "A simple plan, everything included",
		planTitle: "Pay only for what you use:",
		planItems: ["💳 $15 USD / month — first user", "👥 $12 USD / month — per additional user"],
		note: "No contracts. No hidden charges. Cancel anytime.",
		autoTitle: "Paying for Sin Fila is simple and automatic:",
		autoItems: [
			"We accept credit and debit cards directly on the platform",
			"Billing happens automatically every month",
			"You can cancel anytime, no contracts or commitments",
		],
		priceNote: "14 Day free trial",
	},

	referral: {
		title: "Referral Program",
		banner: "Refer a business and both get 1 month free!",
		subtitle: "Invite other businesses and save while you grow with Sin Fila.",
		steps: [
			"Step 1: send your referral code",
			"Step 2: invitee completes their registration",
			"Step 3: both get a free month for a user",
			"* Details available in the app",
		],
	},

	final: {
		text: "Register now for free, and take advantage of our referral program",
		button: "Register Now for free",
	},

	contact: {
		question: "Do you have any questions? We're here to help.",
		website: "reservasinfila.com",
		email: "hola@reservasinfila.com",
		phone: "+1 (514) 758-6041",
	},

	misc: {
  badge: "Sin Fila for business",
  freeMonthsTag: "🎁 Free months",
  labelChallenge: "The Challenge",
  labelResearch: "Research",
  labelHowItWorks: "How It Works",
  labelPricing: "Pricing",
  priceNote: "/ month per user",   // move from pricing.priceNote
},
};

export default businessLandingEN;
